var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userHasPermission(['superAdmin']))?_c('ehc-page',[_c('ehc-properties',{attrs:{"headerText":"All Properties","showRetrieveAllOption":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }